// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import './css/font.css'
import 'animate.css'
import {WOW} from 'wowjs'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
//animate动画库
import animated from 'animate.css'
Vue.use(animated)
const i18n = new VueI18n(
  {
    locale: window.localStorage.getItem('language') == null ? "zh" : window.localStorage.getItem('language'),    // 语言标识
    messages: {
      'zh': require('@/assets/lang/zh'),
      'en': require('@/assets/lang/en')
    }
  }
)

//elementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.config.productionTip = false
Vue.prototype.$wow = new WOW({
  boxClass: 'wow', // default
  animateClass: 'animated', // default
  offset: 150, // default
  mobile: true, // default
  live: true, // default
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js